import axios from "axios";
import React from "react";

import { callPutApi } from "./Apis";
import { dateFormat } from "../../utils/clipUtils";

import jwtDecode from "jwt-decode";

let interval = null;
let intervalLoggingSeq = 0;
const loggingApi = (url, actionBody) => {
    callPutApi("/hiball" + url, actionBody);
};

const loggingFunc = (viewId, userId, loggingKey, criteriaData, userNo) => {
    // console.log(`${viewId}/${loggingKey.getTime()} Logging...`);
    const loggingTime = new Date();
    const loggingDate = dateFormat(loggingTime);

    if(viewId === '/clip/videoList'){
        intervalLoggingSeq++;
    }
    
    if(intervalLoggingSeq > 10){
        // 5분 넘어가면 인터벌 로거 X
    } else {    
        const loggingBody = {
            systemId: "videoClip",
            userId: userId,
            userNo: userNo,
            action: "interval",
            actionData: JSON.stringify(criteriaData),
            viewId: viewId,
            loggingDate: loggingDate,
            loggingTime: loggingTime.getTime(),
            loggingKey: loggingKey.getTime(),
        };

        loggingApi("/api/intervalLogger", loggingBody);
    }
};

export function intervalLogging(viewId) {
    let token = localStorage.getItem("accessToken");
    let criteria = localStorage.getItem("gameCriteria");
    intervalLoggingSeq = 0;

    const loggingKey = new Date();
    if (token && criteria !== "undefined") {
        let criteriaData = JSON.parse(criteria);
        const decoded = jwtDecode(token);
        //console.log(decoded);
        const userId = decoded.roles[0].userId;
        const userNo = decoded.userNo;
        loggingFunc(viewId, userId, loggingKey, criteriaData, userNo);
        if(viewId === '/clip/videoList'){
            interval = setInterval(
                () => loggingFunc(viewId, userId, loggingKey, criteriaData, userNo),
                30000
            );
        }
    }
}

export function stopLogging() {
    if (interval) clearInterval(interval);
}
